import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext";
import {
  BadgeHelp,
  Headset,
  House,
  LogOut,
  Menu,
  User,
  UserRound,
  X,
} from "lucide-react";

function NavBar() {
  const navigate = useNavigate();
  const { logout, isAdmin, plan, saldo, user, autenticado, atualizarUsuarioRemoto } =
    useContext(AuthContext);
  const location = useLocation();
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    atualizarUsuarioRemoto();
  }, [atualizarUsuarioRemoto, location.pathname]);

  const mostrarMenu = () => setMostrar(true);
  const removerMenu = () => setMostrar(false);

  return (
    <div className="text-gray-200 mr-10 mx-auto container bg-blue-500 shadow-md font-questrial">
      {/* Menu para dispositivos móveis */}
      <div
        className={`fixed inset-0 bg-blue-400 w-full flex flex-col justify-start pl-4 pt-2 z-50 transform ${
          mostrar ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        <div className="flex w-full justify-between items-center mt-2 mb-0 px-4">
          <div>
            <img width={90} src="../../images/logo.png" alt="Logotipo" />
          </div>
          <div>
            <X
              width={50}
              size={30}
              onClick={() => removerMenu()}
              className="text-white cursor-pointer hover:text-gray-200 transition duration-200"
            />
          </div>
        </div>
        <div className="space-y-4 flex mt-4 flex-col w-full px-4">
          {isAdmin ? (
            <Link
              to="/admin"
              className={`group flex justify-around items-center w-full border rounded-lg px-4 py-3 transition duration-200 shadow-md ${
                location.pathname === "/admin"
                  ? "bg-blue-500 text-white"
                  : "hover:bg-blue-700 border-t-[1px] shadow-sm text-gray-100 rounded-lg"
              }`}
            >
              <House
                className={`${
                  location.pathname === "/admin" ? "text-white" : "text-gray-100"
                } group-hover:text-gray-100`}
              />
              <span className="w-[60%] text-center font-semibold group-hover:text-gray-100">
                Início
              </span>
            </Link>
          ) : (
            <Link
              to="/home"
              className={`group flex justify-around items-center w-full border rounded-lg px-4 py-3 transition duration-200 shadow-md ${
                location.pathname === "/home"
                  ? "bg-blue-500 text-white"
                  : "hover:bg-blue-700 border-t-[1px] shadow-sm text-gray-100 rounded-lg"
              }`}
            >
              <House
                className={`${
                  location.pathname === "/home" ? "text-white" : "text-gray-100"
                } group-hover:text-gray-100`}
              />
              <span className="w-[60%] text-center font-semibold group-hover:text-gray-100">
                Início
              </span>
            </Link>
          )}
          {isAdmin ? (
            ""
          ) : (
            <div className="flex flex-col gap-4">
              <Link
                to="/quemsomos"
                className={`group flex justify-around items-center w-full border rounded-lg px-4 py-3 transition duration-200 shadow-md ${
                  location.pathname === "/quemsomos"
                    ? "bg-blue-500 text-white"
                    : "hover:bg-blue-700 border-t-[1px] shadow-sm text-gray-300"
                }`}
              >
                <Headset
                  className={`${
                    location.pathname === "/quemsomos"
                      ? "text-gray-100"
                      : "text-gray-100"
                  } group-hover:text-gray-100`}
                />
                <span className="w-[60%] text-center font-semibold text-gray-100 group-hover:text-gray-100">
                  Sobre Nós
                </span>
              </Link>
              <Link
                to="/ajuda"
                className={`group flex justify-around items-center w-full border rounded-lg px-4 py-3 transition duration-200 shadow-md ${
                  location.pathname === "/ajuda"
                    ? "bg-blue-500 text-gray-100"
                    : "hover:bg-blue-700 border-t-[1px] shadow-sm text-gray-100"
                }`}
              >
                <BadgeHelp
                  className={`${
                    location.pathname === "/ajuda"
                      ? "text-white"
                      : "text-gray-100"
                  } group-hover:text-gray-100`}
                />
                <span className="w-[60%] text-center font-semibold group-hover:text-gray-100">
                  Ajuda
                </span>
              </Link>
            </div>
          )}
          <button
            onClick={() => {
              logout();
              navigate("/");
            }}
            className={`group flex justify-around items-center w-full border rounded-lg px-4 py-3 transition duration-200 shadow-md ${
              location.pathname === "/logout"
                ? "bg-blue-500 text-white"
                : "hover:bg-blue-700 border-t-[1px] shadow-sm text-gray-100"
            }`}
          >
            <LogOut
              className={`${
                location.pathname === "/logout" ? "text-white" : "text-gray-100"
              } group-hover:text-gray-100`}
            />
            <span className="w-[60%] text-center font-semibold group-hover:text-gray-100">
              Sair
            </span>
          </button>
        </div>
      </div>

      {/* Container principal do NavBar */}
      <div className="flex mx-auto justify-between items-center p-4">
        {/* Logo */}
        <div className="flex flex-col gap-2">
          <img
            className="sm:w-[100px] w-[68px]"
            src="../../images/logo.png"
            alt="Logotipo"
          />
          <Menu
            className="lg:hidden md:hidden sm:block focus:outline-none text-end"
            size={38}
            onClick={mostrarMenu}
          />
        </div>

        {/* Links para dispositivos médios ou maiores */}
        {isAdmin ? (
          <div>
            <h1 className="lg:text-4xl md:text-3xl">Administrador</h1>
          </div>
        ) : (
          <div className="hidden md:flex lg:flex items-center space-x-4">
            <Link
             to="/home"
             className={`hover:bg-white hover:transition hover:text-blue-500 border rounded-xl px-4 py-2 ${
               location.pathname === "/home"
                 ? "bg-white text-blue-500"
                 : "bg-blue-500 text-white"
             }`}
            >
              Início
            </Link>
            <Link
              to="/quemsomos"
              className={`hover:bg-white hover:transition hover:text-blue-500 border rounded-xl px-4 py-2 ${
                location.pathname === "/quemsomos"
                  ? "bg-white text-blue-500"
                  : "bg-blue-500 text-white"
              }`}
            >
              Nós
            </Link>
            <Link
            to="/ajuda"
              className={`hover:bg-white hover:transition hover:text-blue-500 border rounded-xl px-4 py-2 ${
                location.pathname === "/ajuda"
                  ? "bg-white text-blue-500"
                  : "bg-blue-500 text-white"
              }`}
            >
              Ajuda
            </Link>
          </div>
        )}
        {/* Informações de perfil e logout */}
        <div>
          <div className="hidden md:flex lg:flex items-center space-x-4">
            <div className="text-sm flex items-center space-x-2">
              <span>ola,</span>
              <span className="font-semibold">{user}</span>
            </div>
            {autenticado && (
              <LogOut
                className="hover:text-red-500 cursor-pointer"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              />
            )}
            {isAdmin === false ? (
              <User
                className="hover:text-red-500 cursor-pointer"
                onClick={() => {
                  navigate("/minhaconta");
                }}
              />
            ) : (
              ""
            )}
          </div>
          <div>
            <div className="">
              <div className="lg:hidden md:hidden text-xl flex gap-1 font-bold">
                <div className="text-[12px]">
                  <span>Hello,</span>
                  <span className="font-semibold">{user}</span>
                </div>
                <div>
                  {isAdmin === false ? (
                    <UserRound
                      className="ml-1 hover:text-red-500 text-[12px] cursor-pointer"
                      onClick={() => {
                        navigate("/minhaconta");
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {isAdmin === false && (
                <div>
                  {saldo ? (
                  <span className="text-[12px] text-green-400">
                    {plan} {saldo ? "Ativo" : ""}
                  </span>
                ) : (
                  <span className="text-red-300 font-semibold">
                    Sua Mensalidade Expirou, Pague sua Subscrição!
                  </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Menu Hambúrguer para dispositivos móveis */}
      </div>
    </div>
  );
}

export default NavBar;
